import React from 'react';
import PropTypes from 'prop-types';
import styles from './UserListItem.module.scss';
import { useNavigation } from '../../config/NavigationContext';

const UserListItem = ({
  user,
  handleUserPageNavFromSong,
  onCloseModal,
  isEmojiReaction,
  emoji,
}) => {
  const { handleUserPageNav, handleUserPageNavByHandle } = useNavigation();

  const handleClick = (e) => {
    e.preventDefault();
    if (handleUserPageNavFromSong) {
      handleUserPageNavFromSong(user.uid);
    } else if (user.handle) {
      handleUserPageNavByHandle(user.handle);
    } else {
      handleUserPageNav(user.uid);
    }
    if (onCloseModal) {
      onCloseModal();
    }
  };

  return (
    <div className={styles.listItem} onClick={handleClick}>
      <div
        className={styles.avatar}
        style={{ backgroundImage: `url(${user.avatar})` }}
        title={user.displayName}
      />
      <div className={styles.nameStack}>
        <span className={styles.displayName}>{user.displayName}</span>
        {user.handle && (
          <span className={styles.handle}>@{user.handle}</span>
        )}
      </div>
      {isEmojiReaction && emoji && (
        <span className={styles.emoji}>{emoji}</span>
      )}
    </div>
  );
};

// Add PropTypes for type safety
UserListItem.propTypes = {
  user: PropTypes.shape({
    uid: PropTypes.string.isRequired,
    displayName: PropTypes.string.isRequired,
    avatar: PropTypes.string.isRequired,
  }).isRequired,
  handleUserPageNavFromSong: PropTypes.func,
  onCloseModal: PropTypes.func, // Add PropTypes for the callback
  isEmojiReaction: PropTypes.bool,
  emoji: PropTypes.string,
};

export default UserListItem;
